/**
 * @module getOpenRolesLabel
 */
import { STRINGS } from './strings';
/**
 * Convenience function to get the open roles label based on the jobs count.
 * @param {number} jobsCount -  The number of jobs.
 * @returns {object} Object containing the main and prefix part of the label.
 */
export default function getOpenRolesLabel(jobsCount) {
  return {
    main: jobsCount === 1 ? STRINGS.roles.openOne : STRINGS.roles.openMany,
    prefix: jobsCount || STRINGS.general.no,
  };
}
